import { CompanyContact } from "./Company";

export interface Contact {
  id: number;
  name: string;
  member_number: string;
  first_name: string;
  last_name: string;
}

export const newContact = (): Contact => ({
  id: 0,
  name: "",
  member_number: "",
  first_name: "",
  last_name: "",
});

export interface Member {
  id: number;
  member_number: string;
  first_name: string;
  last_name: string;
  name: string;

  accounting_number?: string;
  employee?: boolean;
  dob?: Date;
  ssn?: string;
  first_membership_date?: Date;
  membership_from_date?: Date;
  membership_to_date?: Date;
  password?: string;
  app_activated_at?: Date;
  web_activated_at?: Date;
  sex_id?: number;

  // used when editing a contact
  emails: Email[];
  phones: Phone[];
  addresses?: Address[];
  company_contacts?: CompanyContact[];
  user_accessgroups?: UserAccessgroup[];
  user_contacts?: UserContact[];

  // used in table-display
  emailaddress?: string
  telephone?: string
  address?: string
  member_type_names?: string
  organization_names?: string
  company_names?: string
}

export interface Email {
  id: number;
  name: string;
  primary: boolean;
}

export interface Phone {
  id: number;
  name: string;
  primary: boolean;
}

export interface Address {
  id: number;
  refrence_id?: number; // either contact_id or company_id
  name: string;
  addressline1: string;
  addressline2: string;
  addressline3: string;
  postcode: string;
  postoffice: string;
  country_id?: number;
  primary: boolean;
  valid_from?: Date;
  valid_to?: Date;
}

export const newMember = (): Member => {
  let email = newEmail();
  email.primary = true;

  let phone = newPhone();
  phone.primary = true;


  return {
    id: 0,
    member_number: "",
    first_name: "",
    last_name: "",
    name: "",
    accounting_number: "",
    employee: false,
    dob: null,
    ssn: "",
    first_membership_date: null,
    membership_from_date: null,
    membership_to_date: null,
    password: "",
    app_activated_at: null,
    web_activated_at: null,
    sex_id: 0,

    emails: [email],
    phones: [phone],
  }
};

export const newEmail = (): Email => ({
  id: 0,
  name: "",
  primary: false,
});

export const newPhone = (): Phone => ({
  id: 0,
  name: "",
  primary: false,
});

export const newAddress = (): Address => ({
  id: 0,
  refrence_id: 0,
  name: "",
  addressline1: "",
  addressline2: "",
  addressline3: "",
  postcode: "",
  postoffice: "",
  country_id: 0,
  primary: false,
});

export interface User {
  id: number;
  name: string;
  password: string;
  pw_expiredate?: Date;
  telephone: string;
  emailaddress: string;
  first_name: string;
  last_name: string;
  username: string;
  oidc_id: string;
  email_verified: boolean;
  phone_verified: boolean;
  is_admin: boolean;

  companies?: string;
  user_companies?: UserCompany[];
  accessgroups?: string;
  user_accessgroups?: UserAccessgroup[];
  contacts?: string;
  user_contacts?: UserContact[];
  organizations?: string;
  user_organizations?: UserOrganization[];
}


export function newUser(): User {
  return {
    id: 0,
    name: "",
    password: "",
    pw_expiredate: null,
    telephone: "",
    emailaddress: "",
    first_name: "",
    last_name: "",
    username: "",
    oidc_id: "",
    email_verified: false,
    phone_verified: false,
    is_admin: false,
  }
}

export interface UserCompany {
  id: number,
  name: string,
  company_name?: string,
  oidc_user_id: number,
  company_id: number,
  from_date: Date | null,
  to_date: Date | null,
}

export function newUserCompany(): UserCompany {
  return {
    id: 0,
    name: "",
    company_name: "",
    oidc_user_id: 0,
    company_id: 0,
    from_date: null,
    to_date: null,
  }
}

export interface UserContact {
  id: number,
  name: string,
  contact_name: string,
  oidc_user_name: string,
  oidc_user_id: number,
  contact_id: number,
  from_date: Date,
  to_date: Date,
}

export function newUserContact(): UserContact {
  return {
    id: 0,
    name: "",
    contact_name: "",
    oidc_user_name: "",
    oidc_user_id: 0,
    contact_id: 0,
    from_date: null,
    to_date: null,
  }
}

export interface UserAccessgroup {
  id: number,
  name?: string,
  accessgroup_name?: string,
  oidc_user_id: number,
  accessgroup_id: number,
  from_date?: Date,
  to_date?: Date,
}

export function newUserAccessgroup(oidc_user_id?: number, accessgroup_id?: number): UserAccessgroup {
  return {
    id: 0,
    oidc_user_id: oidc_user_id ?? 0,
    accessgroup_id: accessgroup_id ?? 0
  }
}

export interface UserOrganization {
  id: number,
  name: string,
  organization_name?: string,
  oidc_user_id: number,
  organization_id: number,
  from_date: Date,
  to_date: Date,
}

export function newUserOrganization(): UserOrganization {
  return {
    id: 0,
    name: "",
    organization_name: "",
    oidc_user_id: 0,
    organization_id: 0,
    from_date: null,
    to_date: null,
  }
}